import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { openWhatsApp } from '../lib/whatsapp';

const { FiArrowUpRight } = FiIcons;

const services = [
  ['01', 'Full-service interiors', 'From first sketches to final styling, we guide every detail of your renovation or new home.'],
  ['02', 'Room refresh', 'A considered edit of layout, color, lighting, and furnishings for the space you already love.'],
  ['03', 'Design direction', 'A focused creative plan and sourcing roadmap to help you make confident decisions.'],
  ['04', 'Commercial spaces', 'Restaurants, boutique retail, and hospitality interiors designed to welcome and linger.'],
  ['05', 'Styling & art curation', 'The finishing layer — objects, textiles, and art that give a room its soul.'],
];

function ServicesSection() {
  return (
    <section className="services-section section-wrap" id="services">
      <div className="services-heading">
        <p className="eyebrow">How we can help</p>
        <h2> Thoughtful, from <br /> <em>start to finish.</em> </h2>
        <p>Good work is a collaboration. Here are a few ways we can make something meaningful together.</p>
        <div className="services-heading-note">
          <span className="services-heading-note-line" />
          <p>Not sure where to begin? That's a good place to start.</p>
        </div>
      </div>
      <div className="services-list">
        {services.map(([number, title, description], index) => (
          <motion.button
            type="button"
            className="service-item"
            key={number}
            onClick={() => openWhatsApp(`Hello Forma Interiors, I'm interested in your "${title}" service.`)}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.45, delay: index * 0.08 }}
          >
            <span className="service-number">{number}</span>
            <div className="service-copy">
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
            <SafeIcon icon={FiArrowUpRight} className="service-arrow" />
          </motion.button>
        ))}
      </div>
    </section>
  );
}

export default ServicesSection;
